const lityElements = $('[data-lity]');
if (lityElements.length) {
    window.lity = require('lity');
}
